module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isHcpView) ? _c('div', [_c('div', {
    staticClass: "gridlist-container"
  }, [_c('mu-grid-list', {
    staticClass: "article"
  }, [_vm._l((_vm.dummy), function(post, index) {
    return (_vm.isLoading) ? _c('mu-grid-tile', {
      key: ("post-" + index),
      staticClass: "pointer"
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.posts), function(post, index) {
    return (!_vm.isLoading) ? _c('mu-grid-tile', {
      key: ("post-" + index),
      staticClass: "pointer",
      nativeOn: {
        "click": function($event) {
          return _vm.goToModule(post.post_slug)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": post.post_video_thumb
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(post.post_title))])]) : _vm._e()
  })], 2)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fa12bba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HCP/SliderModules.vue
// module id = 3047
// module chunks = 1